
import ApprovePrinting from '~/pages/_lang/approve/printing/_id.vue'
export default ApprovePrinting
